export default {
    nlfLogRequest: {
        defaults: {
            endpoint: '/api/v3/nlf-agent/query-log/request',
            rootProperty: 'requests'
        },
        read: {}
    },
    nlfLogQueryDetail: {
        defaults: {
            endpoint: '/api/v3/nlf-agent/query-log/query-details',
            rootProperty: null
        },
        read: {}
    }
}
